export const CREDIT_SCORE_DIALOG_EVENTS: Record<string, string> = {
  resendLink: 'RESEND_LINK',
  verifying: 'VERIFICATION_INPROGRESS',
  verificationFailed: 'VERIFICATION_FAILED',
  registrationFailed: 'REGISTRATION_FAILED',
  registrationSuccess: 'REGISTRATION_SUCCESS',
  refreshFailed: 'REFRESH_FAILED',
};
